import dayjs from 'dayjs';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend, { type HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { resources } from '../../public/locales';
import { availableLanguages, dayjsLocaleMapping } from './constants';
import { glossaryPostProcessor } from './glossary/post-processor';

import 'dayjs/locale/en-ie';
import 'dayjs/locale/ga';

export type { TFunction } from 'i18next';
export { Trans, useTranslation } from 'react-i18next';
export { availableLanguages, dayjsLocaleMapping } from './constants';
export type { GlossaryData } from './glossary/post-processor';
export { setGlossary } from './glossary/post-processor';
export * from './hooks';

export const defaultNS = 'common';

export default i18n
  .use(glossaryPostProcessor)
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    supportedLngs: availableLanguages,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    load: 'languageOnly',
    ns: [defaultNS, 'people', 'templates'],
    debug: process.env.NODE_ENV !== 'production',
    defaultNS,
    fallbackLng: 'en',
    postProcess: ['glossaryReplace'],
    interpolation: {
      escapeValue: false, // no needed for react as it escapes by default
    },
    backend: {
      loadPath: (lngs, nss) => {
        if (process.env.NODE_ENV !== 'production') {
          return '/locales/{{lng}}/{{ns}}.json';
        }

        const lookupLng = lngs?.[0] as (typeof availableLanguages)[number];
        const lookupNs = nss?.[0] as keyof (typeof resources)[typeof lookupLng];
        // @ts-expect-error
        const originalPath = (resources?.[lookupLng]?.[lookupNs] ??
          '') as string;
        return originalPath;
        // return originalPath.replace('/public', '');
      },
    },
  });

i18n.on('languageChanged', (language: (typeof availableLanguages)[number]) => {
  const locale = dayjsLocaleMapping[language];
  dayjs.locale(locale ?? dayjsLocaleMapping.en);
});
